const getFormatedArray = (data) => {
  const formatedArrayResponse = [];
  for (const key in data) {
    if (key && data[key]) {
      formatedArrayResponse.push({
        id: key,
        ...data[key],
      });
    }
  }
  return formatedArrayResponse;
};

export { getFormatedArray };
